import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=8eaeecc8"
import script from "./Snack.vue?vue&type=script&lang=js"
export * from "./Snack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports